import { render, staticRenderFns } from "./IyAppMain.vue?vue&type=template&id=143449cd&scoped=true&"
import script from "./IyAppMain.vue?vue&type=script&lang=js&"
export * from "./IyAppMain.vue?vue&type=script&lang=js&"
import style0 from "./IyAppMain.vue?vue&type=style&index=0&id=143449cd&lang=scss&scoped=true&"
import style1 from "./IyAppMain.vue?vue&type=style&index=1&id=143449cd&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143449cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143449cd')) {
      api.createRecord('143449cd', component.options)
    } else {
      api.reload('143449cd', component.options)
    }
    module.hot.accept("./IyAppMain.vue?vue&type=template&id=143449cd&scoped=true&", function () {
      api.rerender('143449cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/IyAppMain.vue"
export default component.exports